import { useDoctorNotificationsContext } from "../contexts/DoctorNotificationsContext";

/** Хук доступа к непрочитанным уведомлениям врача (polling + mark read). */
export default function useDoctorNotifications() {
    return useDoctorNotificationsContext();
}
